module.exports = __webpack_public_path__ + "media/images/landing/home/american-e42c5cbe66ee0738117b517d7e4db096.png";